// extracted by mini-css-extract-plugin
export default {"mainContainer":"DifficultyProgressStats_mainContainer__aEljX","problemsSolvedText":"DifficultyProgressStats_problemsSolvedText__8h6kS"};